export default __webpack_public_path__ + "ce0ee8c2eb09f57cdd940e1086554e88.jpg";